export default "/fonts/Muli-Medium.ttf?b6c92c76aea74335f0de917be904dd32";